import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useTasksListQuery } from 'api';
import { PreviewContainer, Spinner } from 'components';
import { useWindowSize } from 'hooks';
import { Links } from 'settings';
import { InstanceType } from 'types';

import { EmptyState, TaskListItem } from '../../components';
import { InnerContainer, SeeAllLink, TaskListW } from './styled';

const PREVIEW_SECTION_LIMIT = 3;

export function TasksPreview(): ReactElement {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { isMobile } = useWindowSize();

  const { isLoading, activeTasks, total } = useTasksListQuery({
    type: InstanceType.tasks,
    limit: PREVIEW_SECTION_LIMIT,
    state: '!done',
  });

  return (
    <PreviewContainer
      title={t('we.taskPreview.title')}
      buttonTitle={t('we.taskPreview.action')}
      handleTitleClick={total > 0 ? () => navigate(Links.we.taskManagement.index) : undefined}
      addIconLink={Links.we.createTask}
      maximizeIconLink={total > 0 ? Links.we.taskManagement.index : ''}
      headerSx={{
        display: 'flex',
        alignContent: 'center',
      }}
      containerSx={
        isMobile
          ? { minHeight: '387px', marginBottom: '16px' }
          : { width: '100%', minHeight: '387px', backgroundColor: '#fbfbfb', padding: '16px 0px' }
      }
    >
      <InnerContainer>
        {isLoading && <Spinner size={24} />}

        {!isLoading && activeTasks.length === 0 && <EmptyState />}

        <TaskListW>
          {activeTasks.length > 0 &&
            activeTasks.map(({ title, assigned_to, task, id, comments_count, description }) => (
              <TaskListItem
                key={id}
                id={id}
                title={title}
                assignee={assigned_to}
                description={description}
                deadline={task?.deadline}
                isPreview
                comments_count={comments_count}
                status={task?.state}
                progress={task?.progress}
                priority={task?.priority}
              />
            ))}
          {!isLoading && total > 0 && (
            <SeeAllLink to={Links.we.taskManagement.index}>
              {total > 3 ? `+${total - 3} more` : t('we.taskPreview.seeAll')}
            </SeeAllLink>
          )}
        </TaskListW>
      </InnerContainer>
    </PreviewContainer>
  );
}
